/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getParamedics } from 'app/entities/paramedic/paramedic.reducer';
import { ReferralChargeType } from 'app/shared/model/enumerations/referral-charge-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './paramedic-referral-payment.reducer';

export const ParamedicReferralPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const paramedics = useAppSelector(state => state.paramedic.entities);
  const paramedicReferralPaymentEntity = useAppSelector(state => state.paramedicReferralPayment.entity);
  const loading = useAppSelector(state => state.paramedicReferralPayment.loading);
  const updating = useAppSelector(state => state.paramedicReferralPayment.updating);
  const updateSuccess = useAppSelector(state => state.paramedicReferralPayment.updateSuccess);
  const referralChargeTypeValues = Object.keys(ReferralChargeType);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/paramedic-referral-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getParamedics({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.payment !== undefined && typeof values.payment !== 'number') {
      values.payment = Number(values.payment);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.emergencyHike !== undefined && typeof values.emergencyHike !== 'number') {
      values.emergencyHike = Number(values.emergencyHike);
    }
    if (values.hishRiskHike !== undefined && typeof values.hishRiskHike !== 'number') {
      values.hishRiskHike = Number(values.hishRiskHike);
    }

    const entity = {
      ...paramedicReferralPaymentEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      paramedic: paramedics.find(it => it.id.toString() === values.paramedic?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          referralChargeType: 'CONSULTATION',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...paramedicReferralPaymentEntity,
          doctor: paramedicReferralPaymentEntity?.doctor?.id,
          hospital: paramedicReferralPaymentEntity?.hospital?.id,
          scheme: paramedicReferralPaymentEntity?.scheme?.id,
          paramedic: paramedicReferralPaymentEntity?.paramedic?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paramedicReferralPayment.home.createOrEditLabel" data-cy="ParamedicReferralPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.home.createOrEditLabel">
              Create or edit a ParamedicReferralPayment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paramedic-referral-payment-id"
                  label={translate('tinyMedicRestApp.paramedicReferralPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.payment')}
                id="paramedic-referral-payment-payment"
                name="payment"
                data-cy="payment"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.active')}
                id="paramedic-referral-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.cursor')}
                id="paramedic-referral-payment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.microSec')}
                id="paramedic-referral-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.lastUpdated')}
                id="paramedic-referral-payment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.timestampEntry')}
                id="paramedic-referral-payment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.referralChargeType')}
                id="paramedic-referral-payment-referralChargeType"
                name="referralChargeType"
                data-cy="referralChargeType"
                type="select"
              >
                {referralChargeTypeValues.map(referralChargeType => (
                  <option value={referralChargeType} key={referralChargeType}>
                    {translate(`tinyMedicRestApp.ReferralChargeType.${referralChargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.addedByType')}
                id="paramedic-referral-payment-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.addedByID')}
                id="paramedic-referral-payment-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.modifiedByType')}
                id="paramedic-referral-payment-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.modifiedByID')}
                id="paramedic-referral-payment-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.emergencyHike')}
                id="paramedic-referral-payment-emergencyHike"
                name="emergencyHike"
                data-cy="emergencyHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralPayment.hishRiskHike')}
                id="paramedic-referral-payment-hishRiskHike"
                name="hishRiskHike"
                data-cy="hishRiskHike"
                type="text"
              />
              <ValidatedField
                id="paramedic-referral-payment-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.paramedicReferralPayment.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-payment-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.paramedicReferralPayment.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-payment-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.paramedicReferralPayment.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-payment-paramedic"
                name="paramedic"
                data-cy="paramedic"
                label={translate('tinyMedicRestApp.paramedicReferralPayment.paramedic')}
                type="select"
              >
                <option value="" key="0" />
                {paramedics
                  ? paramedics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paramedic-referral-payment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParamedicReferralPaymentUpdate;
